import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

@Component({
    selector: 'lib-phone-widget-add',
    imports: [SharedModule],
    templateUrl: './phone-widget-add.component.html',
    styleUrl: './phone-widget-add.component.scss'
})
export class PhoneWidgetAddComponent {

}
